import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { SignupCard, CtaButton } from "../../../signupComponents";
import config from "../../../config";

const styles = theme => ({
  wrap: {
    width: "100%",
    maxWidth: 760,
    margin: "0 auto"
  },
  panel: {
    textAlign: "left"
  },
  kicker: {
    color: "#dd3449",
    fontSize: 13,
    fontWeight: 800,
    letterSpacing: 0.5,
    textTransform: "uppercase",
    marginBottom: 8,
    fontFamily: '"Ubuntu","Helvetica","Arial",sans-serif !important'
  },
  title: {
    color: "#094066",
    fontWeight: 800,
    fontSize: 30,
    lineHeight: 1.2,
    marginBottom: 10,
    fontFamily: '"Ubuntu","Helvetica","Arial",sans-serif !important',
    [theme.breakpoints.down("sm")]: {
      fontSize: 24
    }
  },
  body: {
    color: "#526a7a",
    fontSize: 16,
    lineHeight: 1.55,
    marginBottom: 24,
    fontFamily: '"Ubuntu","Helvetica","Arial",sans-serif !important'
  },
  actionRow: {
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      "& button": {
        width: "100%"
      }
    }
  }
});

const InstallAvailability = props => {
  const { classes } = props;

  return (
    <Grid container justify="center" className={classes.wrap}>
      <Grid item xs={12}>
        <SignupCard size="lg" maxw={760}>
          <div className={classes.panel}>
            <Typography className={classes.kicker}>
              Install availability
            </Typography>
            <Typography className={classes.title}>
              Let&apos;s continue your service setup
            </Typography>
            <Typography className={classes.body}>
              This is the next step after location and plan review. We can use
              this screen to collect the remaining details and show available
              install dates.
            </Typography>
            <div className={classes.actionRow}>
              <CtaButton
                component="a"
                href={config.SIGNUP.APP_PATH + "/s/"}
                variant="contained"
              >
                Back to start
              </CtaButton>
            </div>
          </div>
        </SignupCard>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(InstallAvailability);
